// extracted by mini-css-extract-plugin
export default {"section":"GGFDTXOrCs0Ge7H4YEiE"};